import type { Network } from "../types";

export const linkedin: Network = {
  name: "LinkedIn",
  shareUrl: "https://www.linkedin.com/sharing/share-offsite/?url=[u]",
  icon: "/media/images/facebook-social-auth.svg",
  color: "#0A66C2",
};
